import { Link } from 'react-router-dom';

export default function EventosList({ eventos, loading }) {

  function getDayAndMonthAbbreviation(dateString) {
    const date = new Date(dateString);
    const day = date.getUTCDate();
    let monthAbbr = new Intl.DateTimeFormat('es-ES', { month: 'short' }).format(date);
    monthAbbr = monthAbbr.charAt(0).toUpperCase() + monthAbbr.slice(1);

    return { day, monthAbbr };
  }

  return (
    <div className="flex-1 bg-white">
      {loading ? (
        <div className="fixed inset-0 flex items-center justify-center">
          <p className="text-xl font-semibold">Cargando...</p>
        </div>
      ) : eventos.length > 0 ? (
        <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8">
          <div className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8">
            {eventos.map((event, index) => {
              const { day, monthAbbr } = getDayAndMonthAbbreviation(event.fecha);
              return (
                <Link key={index} to={`/eventos/${event.slug}`} >
                  <div className="group relative">
                    <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-3xl bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
                      <img
                        src={`${event.thumbnail}`}
                        className="h-full w-full object-cover object-center"
                      />
                    </div>
                    <h3 className="mt-4 text-2xl font-medium text-black">{event.title}</h3>
                    <div className="absolute top-4 left-4 p-3 bg-black bg-opacity-50 rounded-3xl text-white flex flex-col items-center">
                      <p className='text-3xl'>{monthAbbr}</p>
                      <p className='text-4xl'>{day}</p>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="fixed inset-0 flex items-center justify-center">
          <p className="text-xl font-semibold">No se encontraron eventos para esta búsqueda</p>
        </div>
      )}
    </div>
  );
}
